module.exports = __webpack_public_path__ + "img/beta_white.ad4f2022.svg";